<template>
  <div>
    <template v-if="!bonusCard.isCreated">
      <div class="discount-card__group">
        <div class="discount-card__group__title">{{ bonusCard.typeName }}</div>
        <div class="discount-card__group__value">
          <button
            class="discount-card__create-bonus-card"
            type="button"
            v-on:click="onCreateBonusCardModal"
          >Выпустить
          </button>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="discount-card__group">
        <div class="discount-card__group__title">{{ cardTitle }}</div>
        <div class="discount-card__group__value">
          <the-bonus v-bind:bonuses="bonusCard.amount" />
          <the-tooltip position="bottom">
            <template v-slot:trigger="{ listenerObject }">
              <span v-on="listenerObject">
                <button
                  class="discount-card__button advance-details-open"
                  type="button"
                  v-on:click="openDetailBonusCardSidebar"
                >Детализация {{ bonusCard.typeName }}</button>
              </span>
            </template>
            {{ cardTitle }}
          </the-tooltip>
        </div>
      </div>
    </template>
  </div>

</template>

<script>
import { BonusCard } from '@/mixins/loyaltySystemMixin';
import TheBonus from '@/components/TheBonus.vue';
import TheTooltip from '@/components/TheTooltip.vue';

/**
 * @description Наименование события открытие модального окна создания бонусной карты
 * @type {string}
 */
const NAME_EVENT_CREATE_BONUS_CARD = 'create-bonus-card';
/**
 * @description Наименование события открытие детализации бонусной карты
 * @type {string}
 */
const NAME_EVENT_OPEN_DETAILS_BONUS_CARD = 'open-details-bonus-card';

export default {
  /**
   * @description Бонусная карта
   */
  name: 'BonusCard',
  components: {
    TheTooltip,
    TheBonus,
  },
  computed: {
    /**
     * @description Заголовок карты
     * @returns {string}
     */
    cardTitle() {
      return `${this.bonusCard.typeName} № ${this.bonusCard.number}`;
    },
  },
  props: {
    /**
     * @description Бонусная карта
     * @type {BonusCard}
     */
    bonusCard: {
      type: BonusCard,
      required: true,
    },
  },
  methods: {
    /**
     * @description Обработать событие создания бонусной карты
     * @returns {void}
     */
    onCreateBonusCardModal() {
      this.$emit(NAME_EVENT_CREATE_BONUS_CARD, this.bonusCard);
    },
    /**
     * @description Обработать событие открытие детализации бонусной карты
     * @returns {void}
     */
    openDetailBonusCardSidebar() {
      this.$emit(NAME_EVENT_OPEN_DETAILS_BONUS_CARD, this.bonusCard);
    },
  },
};
</script>
<style lang="scss" scoped>
@use "@/scss/buttons";

.discount-card {
  align-items: center;
  background-color: var(--section-background-color);
  display: flex;
  flex-direction: row;
  gap: 20px 1rem;
  padding: 20px;

  &__group {
    display: flex;
    flex-direction: column;
    gap: 5px;

    &__title {
      color: #90A0B7;
      font-size: 14px;
      line-height: 17px;
    }

    &__value {
      color: #192A3E;
      display: flex;
      flex-direction: row;
      font-weight: 800;
      font-size: 18px;
      gap: .5rem;
      line-height: 21px;
    }
  }

  &__create-bonus-card {
    font-weight: 400;
    color: var(--action-color);
    transition: color 0.3s ease;
    &:hover {
      color: #0076C3;
    }
  }

  &__button {
    display: block;
    position: relative;
    border: 1px solid var(--action-color);
    border-radius: 4px;
    font-size: 0;
    height: 1.5rem;
    width: 1.5rem;

    &.recharge {
      background: no-repeat center url("@/assets/img/plus.svg");
    }

    &.withdrawal {
      background: no-repeat center url("@/assets/img/minus-rounded-blue.svg");
    }

    &.advance-details-open {
      background: no-repeat center url("@/assets/img/trending-up.svg");
    }
  }
}

@media screen and (max-width: 700px) {
  .discount-card__button {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
